module.exports = __webpack_public_path__ + "img/電気回路_1_2_1.ed47f7ab.png";